module.exports = __webpack_public_path__ + "static/media/div1sc.c74a718a.png";